module.exports = __webpack_public_path__ + "static/img/coins_share_bg.628f9a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/coins_share_bg.jpg
// module id = HYT1
// module chunks = 1